/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import Emoji from 'react-emoji-render';
import { useParams } from 'react-router-dom';

import history from '~/services/history';
import api from '~/services/api';
import { Container, Card, ContainerFailed } from './styles';
import loadingContent from '~/assets/animations/loadingContent.json';

export default function Dashboard() {
  const { id } = useParams();
  const [subject, setSubject] = useState('');
  const [modules, setModules] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    async function getData() {
      const { data } = await api.get(`/subjects/${id}`);

      setModules(data.modules);
      setSubject(data);
    }

    getData();
  }, [id]);

  return (
    <>
      {modules.length >= 1 ? (
        <>
          <p
            style={{
              fontSize: 26,
              paddingLeft: 30,
              color: '#36DED6',
              fontWeight: 'bold',
              paddingTop: 30,
            }}
          >
            Módulo: {subject.title}
          </p>
          <p
            style={{
              fontSize: 22,
              paddingLeft: 40,
              color: '#36DED6',
              marginTop: 30,
              marginBottom: -20,
            }}
          >
            Desafios:
          </p>
          <Container>
            {modules.map((module) => {
              const newTitle = module.title.split('- ', 4);
              return (
                <Card key={module.id}>
                  <div className="content">
                    <div className="position">
                      <p>{module.position}</p>
                    </div>
                    <div className="support">
                      <div className="title">
                        <p
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'left',
                            fontSize: 18,
                          }}
                        >
                          {newTitle[2]}
                        </p>
                        <p style={{ textAlign: 'left', fontStyle: 'italic' }}>
                          Nível: {module.level.title}
                        </p>
                      </div>
                      <div className="description">
                        <p style={{ textAlign: 'left', fontSize: 16 }}>
                          {module.objective}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() =>
                        module.level.title === 'Projetos'
                          ? history.push(`/project/${module.id}`)
                          : history.push(`/playground/${module.id}`)
                      }
                    >
                      {module.level.title === 'Projetos'
                        ? 'FAZER PROJETO'
                        : ' FAZER OS DESAFIOS'}
                    </button>
                  </div>
                </Card>
              );
            })}
          </Container>
        </>
      ) : (
        <ContainerFailed>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: loadingContent,
            }}
            height={300}
            width={300}
          />
          <Emoji
            text="Ops! Esse módulo nāo possui desafios ainda."
            style={{ color: '#fff', fontSize: 24, marginTop: -30 }}
          />
          ;
          <button type="submit" onClick={() => history.goBack()}>
            <Emoji
              text="Voltar"
              style={{ color: '#fff', fontSize: 18, fontWeight: 'bold' }}
            />
          </button>
        </ContainerFailed>
      )}
    </>
  );
}
